import { useState } from "react";
import { staticBaseUrl} from "../../config/GlobalConfig";
import { SUPPORT_CONTACT } from "../../const/AppConst";


export default function SubscriptionCoverBloc() {

    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

    const handleOpenModal = () => {
        setModalIsOpen(!modalIsOpen);
    }

    return (

        <div className="bloc-coadherent--cover subscription-cover p-lg va-center hide-in-mobile">
            <div className="subscription-header flex va-center jc-space-between">
                <img src={staticBaseUrl + "/img/mgp.svg"} alt="Logo MGP" className="subscription-logo"/>
                <a className="bleu help-button" onClick={handleOpenModal}><i className="icon-teleconseiller bleu"></i><span>{modalIsOpen ? SUPPORT_CONTACT.match(/.{1,2}/g)?.join(' ') :  "Besoin d'aide ?"}</span></a>
            </div>
            <div className="ta-center p-lg">
                <p className="chapo bleu mb-md">CONTRAT COLLECTIF PSC SANTÉ DU MINISTÈRE DE L'INTÉRIEUR</p>
                <div className="ta-center mb-lg p-x-md">
                    <p className="text">Le ministère de l'Intérieur a retenu la MGP comme partenaire pour la mise en place et la gestion de vos solutions de complémentaire santé.</p>
                </div>
                <span className="border-fushia"></span>
                <h1 className="fz-lg m-y-lg">Je m'identifie et j'accède à mon parcours d'affiliation.</h1>
                <div className="mgp-image-left mgp-image-border-fushia mgp-image-back-bleu image-souscription">
                    <span className="mgp-image-border"></span>
                    <img src={staticBaseUrl + "/img/banner-vad-collectif.jpg"} alt="espace souscription"/>
                </div> 
            </div>
            
        </div>
  )
}